import * as S from './styles';
import { useCalcPrice } from '@/talons';
import { copy } from '@/shared/commonFunctions';
import { useCallback, useMemo, useState } from 'react';
import { ModalFlexDiscount, Product, Slider } from '@/components';
import { CardMode, PackagesTypesProps, ProductProps } from '@/types';

interface Products {
  id: string;
  dots?: boolean;
  cardMode: CardMode;
  products: ProductProps[];
  slideToShow?: number | 'auto';
  onProductNavigate?: (productId: number) => void;
  addProductToCart: ({
    sku,
    uid,
    option_uid,
    quantity,
    category_id,
  }: {
    sku: number;
    uid: string;
    quantity: number;
    option_uid: string;
    category_id: number;
  }) => void;
  updateProductAmount: ({ sku, uid, quantity }: { sku: number; uid: string; quantity: number }) => void;
  removeProductFromCart: ({ uid }: { uid: string }) => void;
  setPageLastPurchase?: (page: number) => void;
}

const RenderSliderProducts = ({
  id,
  dots,
  cardMode,
  products,
  slideToShow,
  setPageLastPurchase,
  onProductNavigate,
}: Products) => {
  const { substTrib } = useCalcPrice();

  const [packQuantity, setPackQuantity] = useState(0);
  const [isOpenedModal, setOpenModal] = useState(false);
  const [packaging, setPackage] = useState('' as PackagesTypesProps);
  const [product, setProduct] = useState(null as ProductProps | null);
  

  // MODIFICAÇÃO AQUI: handleModalFlex agora aceita pack e packQty
  const handleModalFlex = useCallback(
    (prod: ProductProps, selectedPack: PackagesTypesProps, selectedPackQty: number) => {
      const product = copy(prod);
      setProduct(product);
      setPackage(selectedPack);
      setPackQuantity(selectedPackQty);
      setTimeout(() => setOpenModal(true), 300);
    },
    [setProduct, setPackage, setPackQuantity]
  );

  const handleCloseModal = () => {
    setOpenModal(false);
    setProduct(null);
    setPackage('' as PackagesTypesProps);
    setPackQuantity(0);
  };

  const promocoes = useMemo(
    () =>
      products?.map((item: ProductProps, ind: number) => (
        <S.ProductContainer key={`${id}-${ind}`}>
          <Product
            direction={cardMode}
            product={{ ...item }}
            handleModalFlex={handleModalFlex}
            onProductNavigate={onProductNavigate ? () => onProductNavigate(item.COD_PRODUTO) : undefined}
          />
        </S.ProductContainer>
      )) || [],
    [products, cardMode, id, handleModalFlex, onProductNavigate]
  );

  return (
    <>
      <Slider
        id={id}
        canSwipe
        dots={dots}
        slides={promocoes}
        slidesToShow={slideToShow ?? 'auto'}
        className="promotional"
        setActiveIndex={setPageLastPurchase ? setPageLastPurchase : () => {}}
      />

      <ModalFlexDiscount
        pack={packaging}
        product={product as ProductProps}
        packQty={packQuantity}
        substTrib={substTrib}
        isOpenedModal={isOpenedModal}
        setPackage={setPackage}
        openModal={handleCloseModal}
        setPackQuantity={setPackQuantity}
      />
    </>
  );
};

export default RenderSliderProducts;
